import { accountsRoutes } from './accounts/accountsRoute'
import { onboardingRoutes } from './onboarding/onboardingRoute'

import type { RouteRecordRaw } from 'vue-router'

export const propertyOwnersRoutes: RouteRecordRaw[] = [...accountsRoutes, ...onboardingRoutes]
